import strapiConfig from "./strapi-config.json";

export const STRAPI_UPLOADS_BASE_URL = strapiConfig.uploadsBaseUrl;
